// extracted by mini-css-extract-plugin
module.exports = {"field":"LoginForm-module__field___2RO16","input":"LoginForm-module__input___nOg1y","socialColumn":"LoginForm-module__socialColumn___2Yl_-"};